import { render, staticRenderFns } from "./addKeyWord.vue?vue&type=template&id=7de9ab27&scoped=true&"
import script from "./addKeyWord.vue?vue&type=script&setup=true&lang=ts&"
export * from "./addKeyWord.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./addKeyWord.vue?vue&type=style&index=0&id=7de9ab27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9ab27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de9ab27')) {
      api.createRecord('7de9ab27', component.options)
    } else {
      api.reload('7de9ab27', component.options)
    }
    module.hot.accept("./addKeyWord.vue?vue&type=template&id=7de9ab27&scoped=true&", function () {
      api.rerender('7de9ab27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/components/KeyWordSettings/addKeyWord.vue"
export default component.exports